<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required}"
            :for="name">
            {{ label }}
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1">
            <ValidationProvider :name="label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="mt-1">
                    <toggle-button :value="value"
                        v-model="model"
                        :color="{checked: '#38a169', unchecked: '#CCCCCC'}"
                        :sync="true"
                        :labels="{checked: 'Yes', unchecked: 'No'}"
                        :height="height ? height : 39"
                        :width="width ? width : 80"
                        @input="onInput"
                        :disabled="readonly"/>
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "InputToggle",
        props: ['label', 'value', 'name', 'readonly', 'rules', 'mask', 'required', 'type', 'tooltip', 'dollar', 'height', 'width'],
        data: function(){
            return {
                model: null
            }
        },
        mounted() {
            if (this.value === true || this.value === false){
                this.model = this.value;
            }

            // check if the bool value is provided as an int
            if (!this.nodel && this.value === 1){
                this.model = true;
            }

        },
        methods: {
            onInput (event) {
                if (event.target){
                    this.$emit('input', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('input', event);
                }
            }
        }
    }
</script>

<style scoped>

</style>
